export default function PHP_strrpos() {
  return (
    <div>
      <h1>PHP_strrpos</h1>
    </div>
  );
}
